import './TrueFalseQuiz.css';
import questionIcon from '../images/question.png';

const TrueFalseQuiz = ({
  question,
  selectedAnswer,
  isAnswerChecked,
  onSelectAnswer,
}) => {
  if (!question) {
    return null;
  }

  const options = [
    'Adevarat',
    'Fals',
  ];

  return (
    <div className="true-false-quiz-bc">

      <div className="quiz-content-scroll-bc">

        <div className="true-false-container-bc">

  <div className="true-false-question-bc">
  <img
    src={questionIcon}
    alt="Question"
    className="true-false-question-icon-bc"
  />

  <p>{question.question}</p>
</div>

          <div className="true-false-buttons-bc">

            {options.map((option) => {
              let className =
                'true-false-btn-bc';

              if (isAnswerChecked) {
                if (
                  option ===
                  question.correctAnswer
                ) {
                  className =
                    'true-false-btn-bc true-false-correct-bc';
                } else if (
                  option ===
                  selectedAnswer
                ) {
                  className =
                    'true-false-btn-bc true-false-incorrect-bc';
                }
              } else if (
                selectedAnswer === option
              ) {
                className =
                  'true-false-btn-bc true-false-selected-bc';
              }

              return (
                <button
                  key={option}
                  type="button"
                  className={className}
                  disabled={isAnswerChecked}
                  onClick={() =>
                    onSelectAnswer?.(option)
                  }
                >
                  {option === 'Adevarat' ? (
                    <span>
                      ✔ Adevarat
                    </span>
                  ) : (
                    <span>
                      ✘ Fals
                    </span>
                  )}
                </button>
              );
            })}

          </div>

        </div>

      </div>

    </div>
  );
};

export default TrueFalseQuiz;